import { updateDateRangeRefiner } from "./DateRefinerGroup";
import { createRefinerOptions, updateListRefiner } from "./ListsRefinerGroup";
export var RefinerGroupType;
(function (RefinerGroupType) {
    RefinerGroupType[RefinerGroupType["ListRefiner"] = 0] = "ListRefiner";
    RefinerGroupType[RefinerGroupType["DateRange"] = 1] = "DateRange";
})(RefinerGroupType || (RefinerGroupType = {}));
export function isListRefinerGroup(group) {
    return group.refinerGroupType === RefinerGroupType.ListRefiner;
}
export function isDateRangeRefinerGroup(group) {
    return group.refinerGroupType === RefinerGroupType.DateRange;
}
/**
 * Function that returns all ListRefinerGroups from a RefinerGroup list
 */
export const getListRefinerGroups = (groups) => {
    // This was written prior to adding @typescript-eslint/consistent-type-assertions
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return groups.filter((g) => g.refinerGroupType === RefinerGroupType.ListRefiner);
};
/**
 * Function that returns all DateRangeRefinerGroups from a RefinerGroup list
 */
export const getDateRangeRefinerGroups = (groups) => {
    // This was written prior to adding @typescript-eslint/consistent-type-assertions
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return groups.filter((g) => g.refinerGroupType === RefinerGroupType.DateRange);
};
/**
 * Utility function to create Refiner Group by setting required props to default
 * @param group RefinerGroup object with specific properties based on refinerGroupType. The only required property is @property refinerGroupType
 * @returns Refiner group with all mandatory props set to default
 */
export const setupDefaultRefinerGroup = (group) => {
    switch (group.refinerGroupType) {
        case RefinerGroupType.ListRefiner:
            // This was written prior to adding @typescript-eslint/consistent-type-assertions
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return { ...group, selectedSequence: -1, secondaryTextMapping: group.secondaryTextMapping, refinerOptions: "refinerOptions" in group ? group.refinerOptions : [] };
        case RefinerGroupType.DateRange:
            // This was written prior to adding @typescript-eslint/consistent-type-assertions
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return { ...group, selectedSequence: -1, dateRange: group.dateRange ? group.dateRange : null };
    }
};
/**
 * Creates refiner groups based on all the available properties in a set of results.
 * @param data The data to create refiner groups for.
 */
export function createRefinerGroups(data) {
    const refinerGroups = [];
    const allProps = new Set();
    data.forEach((result) => {
        Object.keys(result).forEach((key) => {
            if (allProps.has(key)) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (result[key] instanceof Date) {
                refinerGroups.push(setupDefaultRefinerGroup({ name: key, path: key, refinerGroupType: RefinerGroupType.DateRange }));
            }
            else {
                refinerGroups.push(setupDefaultRefinerGroup({ name: key, path: key, refinerGroupType: RefinerGroupType.ListRefiner }));
            }
            allProps.add(key);
        });
    });
    // This was written prior to adding @typescript-eslint/consistent-type-assertions
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    createRefinerOptions(refinerGroups.filter((rg) => rg.refinerGroupType === RefinerGroupType.ListRefiner), data);
    return refinerGroups;
}
/**
 * Updates refiner group sequence based on selection.
 */
const updateRefinerGroupSequence = ({ isSelected, refinerGroups, changedRefinerGroup }) => {
    if (isSelected) {
        //This group no longer has any options selected, remove it from the sequences.
        const sequenceRemoved = changedRefinerGroup.selectedSequence;
        changedRefinerGroup.selectedSequence = -1;
        //Resequence others.
        refinerGroups.forEach((group) => {
            if (group.selectedSequence > sequenceRemoved) {
                group.selectedSequence--;
            }
        });
    }
    else if (changedRefinerGroup.selectedSequence === -1) {
        //This group has its first option selected, so add it to the sequences selected. Add at the end.
        changedRefinerGroup.selectedSequence = refinerGroups.reduce((max, g) => Math.max(max, g.selectedSequence), -1) + 1;
    }
};
/**
 * Updates the counts on the refiner options.  Returns a filtered set of results.
 * @param results The full selection of results.
 * @param refinerGroups The refiner groups.
 * @param changedRefinerGroup The group that the changed refiner option belongs to.
 */
export function updateRefinerCounts(results, refinerGroups, changedRefinerGroup) {
    switch (changedRefinerGroup.refinerGroupType) {
        case RefinerGroupType.ListRefiner:
            updateRefinerGroupSequence({ isSelected: !changedRefinerGroup.refinerOptions.find((o) => o.isSelected), changedRefinerGroup: changedRefinerGroup, refinerGroups: refinerGroups });
            break;
        case RefinerGroupType.DateRange:
            updateRefinerGroupSequence({
                isSelected: !changedRefinerGroup.dateRange || (!changedRefinerGroup.dateRange.fromDate && !changedRefinerGroup.dateRange.toDate),
                changedRefinerGroup: changedRefinerGroup,
                refinerGroups: refinerGroups
            });
    }
    let filteredResults = results;
    refinerGroups
        .sort((n1, n2) => (n1.selectedSequence === -1 ? 999 : n1.selectedSequence) - (n2.selectedSequence === -1 ? 999 : n2.selectedSequence))
        .forEach((group) => {
        let newFilteredResults = null;
        switch (group.refinerGroupType) {
            case RefinerGroupType.ListRefiner:
                newFilteredResults = updateListRefiner({ group: group, results: filteredResults });
                break;
            case RefinerGroupType.DateRange:
                newFilteredResults = updateDateRangeRefiner({ group: group, results: filteredResults });
        }
        if (newFilteredResults !== null) {
            filteredResults = newFilteredResults;
        }
    });
    return filteredResults;
}
